<template>
    <div class="field has-addons">
        <div class="control">
            <input class="input is-small"  v-bind:class="{ 'is-danger': error }" v-model="newBid.result_price" v-on:change="bidResult()" type="text"  placeholder="Result">
        </div>
        <p class="control">
            <a class="button is-static is-small">
                000 ¥
            </a>
        </p>
    </div>
</template>

<script>
    import apiBids from '../../api/apiBids'
    export default {
        props:['bid'],
        data() {
            return {
                error: false,
                newBid: {
                    id: this.bid.id,
                    result_price: this.bid.result_price,
                    group_name: this.bid.group.name,
                    group_id: this.bid.group.id
                }
            }
        },
        methods: {
            bidResult() {
                this.error = false
                apiBids
                    .updateBidRequest(this.newBid)
                    .then((response) => {

                    })
                    .catch((err) => {
                        console.log(err)
                        if ( err.response && err.response.status === 422 ) {
                            this.error = true
                        }
                    })
            }
        },
        mounted () {

        }
    }

</script>

<style scoped>
    .field {
        min-width: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Bids/BidResult.vue